let redis: any = null;

if (typeof window === "undefined") {
    const Redis = require("ioredis");
    redis = new Redis({
        host: process.env.REDIS_HOST || "redis-service",
        port: Number(process.env.REDIS_PORT) || 6379,
        password: process.env.REDIS_PASSWORD || undefined, // Se houver senha configurada
    });
}

export default redis;
